export default {
  name: "dataEmpty",
  props: {
    className: {
      type: String,
      default: "data-empty"
    }
  }
};